import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import AboutTop from "components/AboutTop";
import WeHaveSection from "components/WeHaveSection";
import VissionMission from "components/VisionMission";
import ValuesSection from "components/ValuesSection";

const AboutPage = () => {
  return (
    <Layout>
      <SEO title="About" />
      <div className="container">
        <AboutTop />
        <WeHaveSection />
        <VissionMission />
        <ValuesSection />
      </div>
    </Layout>
  );
};

export default AboutPage;
